import { footerData } from '@/mocks/home';

export default function Footer() {
  return (
    <footer id="footer" className="w-full bg-background-950 text-background-300">
      <div className="max-w-[1400px] mx-auto px-4 md:px-6 py-12 md:py-16">
        <div className="grid grid-cols-1 md:grid-cols-3 gap-10 mb-10">
          <div>
            <span className="text-xl font-bold text-background-50 font-heading">51大赛</span>
            <span className="ml-2 text-xs text-background-400 bg-background-800 px-2 py-0.5 rounded whitespace-nowrap">讨论社区</span>
            <p className="mt-4 text-sm text-background-400 leading-relaxed">{footerData.description}</p>
          </div>
          <div>
            <h3 className="text-sm font-semibold text-background-100 mb-4">快速导航</h3>
            <div className="space-y-2.5">
              {footerData.links.map((link) => (
                <a key={link.href} href={link.href} className="block text-sm text-background-400 hover:text-background-100 transition-colors whitespace-nowrap">
                  {link.label}
                </a>
              ))}
            </div>
          </div>
          <div>
            <h3 className="text-sm font-semibold text-background-100 mb-4">合作伙伴</h3>
            <p className="text-sm text-background-500 leading-relaxed">更多优质合作伙伴即将入驻，敬请期待。</p>
          </div>
        </div>
        <div className="border-t border-background-800 pt-6 flex flex-col sm:flex-row items-center justify-between gap-4">
          <p className="text-xs text-background-500">2026 51大赛 版权所有</p>
          <div className="flex items-center gap-4">
            <span className="text-xs text-background-600 cursor-pointer hover:text-background-300 transition-colors whitespace-nowrap">用户协议</span>
            <span className="text-xs text-background-600 cursor-pointer hover:text-background-300 transition-colors whitespace-nowrap">隐私政策</span>
            <span className="text-xs text-background-600 cursor-pointer hover:text-background-300 transition-colors whitespace-nowrap">社区规范</span>
          </div>
        </div>
      </div>
    </footer>
  );
}